enum HttpMethod {
	PATCH = 'PATCH',
	GET = 'GET',
	POST = 'POST',
	DELETE = 'DELETE',
	PUT = 'PUT',
}

export default HttpMethod;
